import { createFileRoute } from '@tanstack/react-router'

import { InvoicesPage } from '../../../../components/pages/invoices-and-payments/invoices-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/(customer)/_portal/invoices')({
  component: () => (
    <PermissionChecker requiredPermissions={['invoice.read']}>
      <InvoicesPage />
    </PermissionChecker>
  ),
})
